import { render, staticRenderFns } from "./PromotionsListPage.vue?vue&type=template&id=dbb1180c&scoped=true"
import script from "./PromotionsListPage.vue?vue&type=script&lang=js"
export * from "./PromotionsListPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionsListPage.vue?vue&type=style&index=0&id=dbb1180c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb1180c",
  null
  
)

export default component.exports